/**
 * Returns true if a and b are the same calendar day
 * @param {Date} a 
 * @param {Date} b 
 * @returns {boolean}
 */
export const isSameDate = (a, b) => {
    return a.getDate() === b.getDate() &&
        a.getMonth() === b.getMonth() &&
        a.getFullYear() === b.getFullYear();
};